export default "__VITE_PUBLIC_ASSET__e0645d8a__"